// Email typo detection focused on domain-level suggestions.
// Avoids false positives for country-code TLDs like .co.uk by comparing only the last two labels.

const COMMON_TYPOS: Array<{ wrong: string; correct: string }> = [
  { wrong: 'gmial.com', correct: 'gmail.com' },
  { wrong: 'gmai.com', correct: 'gmail.com' },
  { wrong: 'gmail.co', correct: 'gmail.com' },
  { wrong: 'yahooo.com', correct: 'yahoo.com' },
  { wrong: 'yahoo.co', correct: 'yahoo.com' },
  { wrong: 'hotmial.com', correct: 'hotmail.com' },
  { wrong: 'hotmail.co', correct: 'hotmail.com' },
];

export function getEmailTypoSuggestion(email: string): string | null {
  const trimmed = String(email || '').trim().toLowerCase();
  const parts = trimmed.split('@');
  if (parts.length !== 2) return null;
  const [local, domain] = parts;
  if (!local || !domain) return null;

  const lastTwo = domain.split('.').slice(-2).join('.') || '';
  const typo = COMMON_TYPOS.find((t) => lastTwo === t.wrong);
  if (!typo) return null;

  const correctedDomain = domain.replace(new RegExp(`${typo.wrong}$`), typo.correct);
  return `${local}@${correctedDomain}`;
}

